const $btns = document.querySelectorAll('[data-toggle-mobile-nav]');
const $body = document.querySelector('body');

$btns.forEach(($btn) => {
    $btn.addEventListener('click', (e) => {
        e.preventDefault();
        if ($body.classList.contains('-show-mobile-nav')) {
            $body.classList.remove('-show-mobile-nav');
        } else {
            $body.classList.add('-show-mobile-nav');
        }
    });
});
